import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/pay/event/';

function baseApi() {

    function queryList(data) {
        return Post(baseUrl + 'queryPayEvent', data);
    }


    return {
        queryList
    };
}

export const exportPayEventApi = baseApi();
